import api from './services/api';

// Convert VAPID key
function urlBase64ToUint8Array(base64String) {
  const padding = '='.repeat((4 - base64String.length % 4) % 4);
  const base64 = (base64String + padding)
    .replace(/\-/g, '+')
    .replace(/_/g, '/');

  const rawData = window.atob(base64);
  const outputArray = new Uint8Array(rawData.length);

  for (let i = 0; i < rawData.length; ++i) {
    outputArray[i] = rawData.charCodeAt(i);
  }
  return outputArray;
}

/**
 * ✅ Check if already subscribed (no permission request here)
 */
export const checkNotificationStatus = async () => {
  if (!('serviceWorker' in navigator)) return false;

  try {
    const registration = await navigator.serviceWorker.getRegistration();
    if (!registration) return false;

    const subscription = await registration.pushManager.getSubscription();
    return !!subscription;
  } catch (error) {
    console.error('[Push Notifications] Status check error:', error);
    return false;
  }
};

/**
 * ✅ MAIN FUNCTION (call ONLY on button click)
 */
export const subscribeUser = async () => {
  console.log('[Push Notifications] Starting subscription...');

  if (!('serviceWorker' in navigator) || !('PushManager' in window)) {
    console.warn('[Push Notifications] Not supported by this browser.');
    return;
  }

  try {
    // 🚨 MUST be triggered by user click
    const permission = await Notification.requestPermission();

    if (permission !== 'granted') {
      console.log('[Push Notifications] Permission denied.');
      return;
    }

    // Register service worker
    const registration = await navigator.serviceWorker.register('/service-worker.js');
    console.log('[Service Worker] Registered');

    // Check existing subscription
    let subscription = await registration.pushManager.getSubscription();

    if (!subscription) {
      console.log('[Push Notifications] Creating new subscription...');

      subscription = await registration.pushManager.subscribe({
        userVisibleOnly: true,
        applicationServerKey: urlBase64ToUint8Array(
          process.env.REACT_APP_VAPID_PUBLIC_KEY
        )
      });
    } else {
      console.log('[Push Notifications] Already subscribed');
    }

    console.log('[Push Notifications] Subscription:', subscription);

    // Send to backend
    await api.post('/api/subscribe', { subscription });

    console.log('[Push Notifications] Successfully subscribed');

    return true;
  } catch (error) {
    console.error('[Push Notifications] Error:', error);
    return false;
  }
};

/**
 * ✅ Optional: Unsubscribe (useful for logout/settings)
 */
export const unsubscribeUser = async () => {
  try {
    const registration = await navigator.serviceWorker.getRegistration();
    if (!registration) return;

    const subscription = await registration.pushManager.getSubscription();
    if (!subscription) return;

    await subscription.unsubscribe();
    console.log('[Push Notifications] Unsubscribed');

    // Optional: notify backend
    await api.post('/api/unsubscribe', { subscription });

  } catch (error) {
    console.error('[Push Notifications] Unsubscribe error:', error);
  }
};